import { memo } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

/**
 * BottomLoading component displays a loading indicator centered
 * within a div. It is typically used to indicate that content is
 * being loaded or processed.
 *
 * @returns {JSX.Element} A div containing a CircularProgress component.
 */
function BottomLoading(): JSX.Element {
  return (
    <div
      style={{
        marginTop: 20,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <CircularProgress size={30} />
    </div>
  );
}

export default memo(BottomLoading);
